module.exports = __webpack_public_path__ + "img/BigVLogo.f57b3fdd.png";